"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1850,7911],{

/***/ 18987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Button = function Button(_ref) {
  var onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      nolink = _ref.nolink;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn ",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    children: src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__.Link, {
      href: src || '/',
      children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Load_More",
        "data-name": "Button - Load More",
        width: "169",
        height: "44",
        viewBox: "0 0 169 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          opacity: "0.5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "169",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "168",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Group_4832",
          "data-name": "Group 4832",
          transform: "translate(15497 -2196)",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4824",
            "data-name": "Group 4824",
            transform: "translate(-13767.5 1559) rotate(90)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4823",
              "data-name": "Group 4823",
              transform: "translate(11 4)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_9",
                "data-name": "Line 9",
                x2: "5",
                y2: "5",
                transform: "translate(647.5 1592.5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_10",
                "data-name": "Line 10",
                x1: "5",
                y2: "5",
                transform: "translate(647.5 1597.5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
              id: "Line_11",
              "data-name": "Line 11",
              x2: "10",
              transform: "translate(653.5 1601.5)",
              fill: "none",
              stroke: "".concat(color ? color : 'white'),
              strokeLinecap: "round",
              strokeWidth: "1"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Load_More",
            "data-name": "Load More",
            transform: "translate(-15461 2223)",
            fill: "".concat(color ? color : 'white'),
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "0",
              y: "0",
              children: "Load More"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 5695",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          opacity: '0',
          strokeDasharray: "0 520",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "169",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "168",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Open_an_Account_Now",
        "data-name": "Button - Open an Account Now",
        xmlns: "http://www.w3.org/2000/svg",
        width: "238",
        height: "44",
        viewBox: "0 0 238 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          opacity: "0.3",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 493",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          strokeDasharray: "2 520",
          opacity: "0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
          id: "Open_an_Account_Now",
          "data-name": "Open an Account Now",
          transform: "translate(36 27)",
          fill: "#fff",
          "font-size": "16",
          "font-family": "Avenir-Medium, Avenir",
          "font-weight": "500",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
            x: "0",
            y: "0",
            children: text
          })
        })]
      })
    }) : nolink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      href: 'javascript:void(0)',
      children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Load_More",
        "data-name": "Button - Load More",
        width: "169",
        height: "44",
        viewBox: "0 0 169 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          opacity: "0.5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "169",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "168",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Group_4832",
          "data-name": "Group 4832",
          transform: "translate(15497 -2196)",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4824",
            "data-name": "Group 4824",
            transform: "translate(-13767.5 1559) rotate(90)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4823",
              "data-name": "Group 4823",
              transform: "translate(11 4)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_9",
                "data-name": "Line 9",
                x2: "5",
                y2: "5",
                transform: "translate(647.5 1592.5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_10",
                "data-name": "Line 10",
                x1: "5",
                y2: "5",
                transform: "translate(647.5 1597.5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
              id: "Line_11",
              "data-name": "Line 11",
              x2: "10",
              transform: "translate(653.5 1601.5)",
              fill: "none",
              stroke: "".concat(color ? color : 'white'),
              strokeLinecap: "round",
              strokeWidth: "1"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Load_More",
            "data-name": "Load More",
            transform: "translate(-15461 2223)",
            fill: "".concat(color ? color : 'white'),
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "0",
              y: "0",
              children: "Load More"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 5695",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          opacity: '0',
          strokeDasharray: "0 520",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "169",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "168",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        })]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Open_an_Account_Now",
        "data-name": "Button - Open an Account Now",
        xmlns: "http://www.w3.org/2000/svg",
        width: "238",
        height: "44",
        viewBox: "0 0 238 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          opacity: "0.3",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 493",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          strokeDasharray: "2 520",
          opacity: "0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
          id: "Open_an_Account_Now",
          "data-name": "Open an Account Now",
          transform: "translate(36 27)",
          fill: "#fff",
          fontSize: "16",
          fontFamily: "Avenir-Medium, Avenir",
          fontWeight: "500",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
            x: "0",
            y: "0",
            children: text
          })
        })]
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        children: text
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ButtonLoadMore__StyledBtn",
  componentId: "sc-krq5nh-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:fit-content;height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);box-sizing:border-box;color:", ";svg{width:auto;height:100%;#Rectangle_493{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}span{transition:color 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;margin-top:5px;z-index:2;line-height:45px;}@keyframes dash{from{stroke-dashoffset:0;}to{stroke-dashoffset:550px;}}&:hover{svg{line{stroke:", ";}#Rectangle_493{opacity:1;strokeDasharray:550px;}}&:before{transform:translate(0);}}&:focus{color:#222222;}&:hover{color:#222222;}}.ok{position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;transform:translateX(0.25px);margin:0;rect{rx:calc(20 / 2);ry:calc(20 / 2);stroke:#3C3C3B;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "transparent";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 77911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68777);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Button = function Button(_ref) {
  var onSubmit = _ref.onSubmit,
      text = _ref.text,
      src = _ref.src,
      img = _ref.img,
      hoverImg = _ref.hoverImg,
      fontSize = _ref.fontSize,
      fontWeight = _ref.fontWeight,
      color = _ref.color,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      margin = _ref.margin,
      background = _ref.background,
      borderRadius = _ref.borderRadius,
      border = _ref.border,
      width = _ref.width,
      height = _ref.height,
      hoverBackground = _ref.hoverBackground,
      target = _ref.target,
      borderColor = _ref.borderColor,
      hoverColor = _ref.hoverColor,
      icon = _ref.icon,
      newtablink = _ref.newtablink,
      svgwidth = _ref.svgwidth,
      popup = _ref.popup,
      ex = _ref.ex;
  var svgOne = "\n    <svg id=\"Button_-_Contact_Us\" data-name=\"Button - Contact Us\" xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(svgwidth ? svgwidth : '170', "\" height=\"44\" viewBox=\"0 0 ").concat(svgwidth ? svgwidth : '170', " 44\">\n        <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeWidth=\"1\" opacity=\"0.5\">\n            <rect width=\"").concat(svgwidth ? svgwidth : '170', "\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n            <rect x=\"0.5\" y=\"0.5\" width=\"").concat(svgwidth ? svgwidth - 1 : '169', "\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n        </g>\n        <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeWidth=\"1\" strokeDasharray=\"0 520\" opacity=\"0\">\n            <rect width=\"").concat(svgwidth ? svgwidth : '170', "\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n            <rect x=\"0.5\" y=\"0.5\" width=\"").concat(svgwidth ? svgwidth - 1 : '169', "\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n        </g>\n        <g id=\"Group_4825\" data-name=\"Group 4825\" transform=\"translate(36 12)\">\n            <text id=\"Contact_Us\" data-name=\"Contact Us\" transform=\"").concat(svgwidth ? 'translate(-5 15)' : 'translate(0 15)', "\" fill=\"").concat(color ? color : '#3C3C3B', "\" font-size=\"16\" font-family=\"Avenir-Medium, Avenir\" font-weight=\"500\">\n                <tspan x=\"").concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n            </text>\n            <g id=\"Group_4824\" data-name=\"Group 4824\" transform=\"").concat(svgwidth ? 'translate(135 4.5)' : ex ? "translate(97 4.5)" : 'translate(95 4.5)', "\">\n                <g id=\"Group_4823\" data-name=\"Group 4823\" transform=\"translate(5)\">\n                    <line id=\"Line_9\" data-name=\"Line 9\" x2=\"5\" y2=\"5\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n                    <line id=\"Line_10\" data-name=\"Line 10\" x1=\"5\" y2=\"5\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n                </g>\n                <line id=\"Line_11\" data-name=\"Line 11\" x2=\"10\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : '#3C3C3B', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n            </g>\n        </g>\n    </svg>");
  var svgTwo = "\n    <svg id=\"Button_-_Open_an_Account_Now\" data-name=\"Button - Open an Account Now\" xmlns=\"http://www.w3.org/2000/svg\" width=\"238\" height=\"44\" viewBox=\"0 0 238 44\">\n      <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" opacity=\"0.3\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" strokeDasharray=\"2 520\" opacity=\"0\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <text id=\"Open_an_Account_Now\" data-name=\"Open an Account Now\" transform=\"translate(36 27)\" fill=\"#fff\" fontSize=\"16\" fontFamily=\"Avenir-Medium, Avenir\" fontWeight=\"500\">\n        <tspan x=\"".concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n      </text>\n    </svg>");
  var svgThree = "\n    <svg id=\"Button_-_Contact_Us\" data-name=\"Button - Contact Us\" xmlns=\"http://www.w3.org/2000/svg\" width=\"170\" height=\"44\" viewBox=\"0 0 170 44\">\n      <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"".concat(color ? color : 'white', "\" strokeWidth=\"1\" opacity=\"0.5\">\n        <rect width=\"170\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"169\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeWidth=\"1\" strokeDasharray=\"0 520\" opacity=\"0\">\n        <rect width=\"170\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"169\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Group_4825\" data-name=\"Group 4825\" transform=\"translate(36 12)\">\n        <text id=\"Contact_Us\" data-name=\"Contact Us\" transform=\"translate(0 15)\" fill=\"").concat(color ? color : 'white', "\" fontSize=\"16\" fontFamily=\"Avenir-Medium, Avenir\" fontWeight=\"500\">\n          <tspan x=\"").concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n        </text>\n        <g id=\"Group_4824\" data-name=\"Group 4824\" transform={ex ? \"translate(97 4.5)\" :\"translate(92 4.5)\"}>\n          <g id=\"Group_4823\" data-name=\"Group 4823\" transform=\"translate(5)\">\n            <line id=\"Line_9\" data-name=\"Line 9\" x2=\"5\" y2=\"5\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n            <line id=\"Line_10\" data-name=\"Line 10\" x1=\"5\" y2=\"5\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n          </g>\n          <line id=\"Line_11\" data-name=\"Line 11\" x2=\"10\" transform=\"translate(0 5)\" fill=\"none\" stroke=\"").concat(color ? color : 'white', "\" strokeLinecap=\"round\" strokeWidth=\"1\"/>\n        </g>\n      </g>\n    </svg>");
  var svgFour = "\n    <svg id=\"Button_-_Open_an_Account_Now\" data-name=\"Button - Open an Account Now\" xmlns=\"http://www.w3.org/2000/svg\" width=\"238\" height=\"44\" viewBox=\"0 0 238 44\">\n      <g id=\"Rectangle_492\" data-name=\"Rectangle 492\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" opacity=\"0.3\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <g id=\"Rectangle_493\" data-name=\"Rectangle 493\" fill=\"none\" stroke=\"#fff\" strokeWidth=\"1\" strokeDasharray=\"2 520\" opacity=\"0\">\n        <rect width=\"238\" height=\"44\" rx=\"22\" stroke=\"none\"/>\n        <rect x=\"0.5\" y=\"0.5\" width=\"237\" height=\"43\" rx=\"21.5\" fill=\"none\"/>\n      </g>\n      <text id=\"Open_an_Account_Now\" data-name=\"Open an Account Now\" transform=\"translate(36 27)\" fill=\"#fff\" fontSize=\"16\" fontFamily=\"Avenir-Medium, Avenir\" fontWeight=\"500\">\n        <tspan x=\"".concat(popup ? '-10' : '0', "\" y=\"0\">").concat(text, "</tspan>\n      </text>\n    </svg>");
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBtn, {
    className: "dc-btn ",
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    background: background,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    margin: margin,
    border: border,
    img: img,
    borderRadius: borderRadius,
    width: width,
    hoverImg: hoverImg,
    hoverBackground: hoverBackground,
    height: height,
    borderColor: borderColor,
    target: target,
    hoverColor: hoverColor,
    onSubmit: onSubmit,
    children: src ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: src || '/',
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: svgOne
          }
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
          id: "Button_-_Open_an_Account_Now",
          "data-name": "Button - Open an Account Now",
          xmlns: "http://www.w3.org/2000/svg",
          width: "238",
          height: "44",
          viewBox: "0 0 238 44",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_492",
            "data-name": "Rectangle 492",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            opacity: "0.3",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Rectangle_493",
            "data-name": "Rectangle 493",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "1",
            strokeDasharray: "2 520",
            opacity: "0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              width: "238",
              height: "44",
              rx: "22",
              stroke: "none"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
              x: "0.5",
              y: "0.5",
              width: "237",
              height: "43",
              rx: "21.5",
              fill: "none"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Open_an_Account_Now",
            "data-name": "Open an Account Now",
            transform: "translate(36 27)",
            fill: "#fff",
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "".concat(popup ? '-10' : '0'),
              y: "0",
              children: text
            })
          })]
        }) // <div dangerouslySetInnerHTML={{ __html: svgTwo }} />

      })
    }) : newtablink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      href: newtablink,
      target: target || '_self',
      children: icon ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Contact_Us",
        "data-name": "Button - Contact Us",
        xmlns: "http://www.w3.org/2000/svg",
        width: "170",
        height: "44",
        viewBox: "0 0 170 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          opacity: "0.5",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "170",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "169",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 493",
          fill: "none",
          stroke: "".concat(color ? color : 'white'),
          strokeWidth: "1",
          strokeDasharray: "0 520",
          opacity: "0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "170",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "169",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Group_4825",
          "data-name": "Group 4825",
          transform: "translate(36 12)",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
            id: "Contact_Us",
            "data-name": "Contact Us",
            transform: "translate(0 15)",
            fill: "".concat(color ? color : 'white'),
            "font-size": "16",
            "font-family": "Avenir-Medium, Avenir",
            "font-weight": "500",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
              x: "".concat(popup ? '-10' : '0'),
              y: "0",
              children: text
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
            id: "Group_4824",
            "data-name": "Group 4824",
            transform: ex ? "translate(97 4.5)" : "translate(95 4.5)",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
              id: "Group_4823",
              "data-name": "Group 4823",
              transform: "translate(5)",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_9",
                "data-name": "Line 9",
                x2: "5",
                y2: "5",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
                id: "Line_10",
                "data-name": "Line 10",
                x1: "5",
                y2: "5",
                transform: "translate(0 5)",
                fill: "none",
                stroke: "".concat(color ? color : 'white'),
                strokeLinecap: "round",
                strokeWidth: "1"
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("line", {
              id: "Line_11",
              "data-name": "Line 11",
              x2: "10",
              transform: "translate(0 5)",
              fill: "none",
              stroke: "".concat(color ? color : 'white'),
              strokeLinecap: "round",
              strokeWidth: "1"
            })]
          })]
        })]
      }) // <div dangerouslySetInnerHTML={{ __html: svgThree }} />
      : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
        id: "Button_-_Open_an_Account_Now",
        "data-name": "Button - Open an Account Now",
        xmlns: "http://www.w3.org/2000/svg",
        width: "238",
        height: "44",
        viewBox: "0 0 238 44",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_492",
          "data-name": "Rectangle 492",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          opacity: "0.3",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", {
          id: "Rectangle_493",
          "data-name": "Rectangle 493",
          fill: "none",
          stroke: "#fff",
          strokeWidth: "1",
          strokeDasharray: "2 520",
          opacity: "0",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            width: "238",
            height: "44",
            rx: "22",
            stroke: "none"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "237",
            height: "43",
            rx: "21.5",
            fill: "none"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("text", {
          id: "Open_an_Account_Now",
          "data-name": "Open an Account Now",
          transform: "translate(36 27)",
          fill: "#fff",
          "font-size": "16",
          "font-family": "Avenir-Medium, Avenir",
          "font-weight": "500",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("tspan", {
            x: "".concat(popup ? '-10' : '0'),
            y: "0",
            children: text
          })
        })]
      }) // <div dangerouslySetInnerHTML={{ __html: svgFour }} />

    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      target: target || '_self',
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        children: text
      })
    })
  });
};

var StyledBtn = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ButtonNormal__StyledBtn",
  componentId: "sc-hzc75b-0"
})(["&.dc-btn{margin:", ";width:", ";height:", "px;cursor:pointer;a{display:flex;width:fit-content;height:100%;align-items:center;justify-content:center;font-size:", "px;font-weight:", ";margin:0;line-height:", "px;background-color:", ";position:relative;border-radius:", "px;overflow:hidden;z-index:0;transition:border 1s cubic-bezier(.25,.74,.22,.99);box-sizing:border-box;color:", ";svg{width:auto;height:100%;#Rectangle_493{transition:all 1s cubic-bezier(.25,.74,.22,.99);}}span{transition:color 1s cubic-bezier(.25,.74,.22,.99);color:", ";position:relative;margin-top:5px;z-index:2;line-height:45px;}@keyframes dash{from{stroke-dashoffset:0;}to{stroke-dashoffset:550px;}}&:hover{svg{line{stroke:", ";}#Rectangle_493{opacity:1;strokeDasharray:550px;}}&:before{transform:translate(0);}}&:focus{color:#222222;}&:hover{color:#222222;}}.ok{position:absolute;left:0;top:0;width:100%;height:100%;overflow:visible;transform:translateX(0.25px);margin:0;rect{rx:calc(20 / 2);ry:calc(20 / 2);stroke:#3C3C3B;}}}"], function (props) {
  return props.margin || '0';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '44';
}, function (props) {
  return props.fontSize || '16';
}, function (props) {
  return props.fontWeight || 500;
}, function (props) {
  return props.lineHeight || '24';
}, function (props) {
  return props.background || "transparent";
}, function (props) {
  return props.borderRadius || '22';
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.color || "#3C3C3B";
}, function (props) {
  return props.hoverColor || '#FFF';
});
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(Button));

/***/ }),

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 98508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      placeholder: "blur",
      objectFit: 'cover',
      layout: 'fill',
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-ncc5rv-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:130%;object-fit:", ";position:absolute;top:-50px;left:0;right:0;bottom:0;will-change:transform;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ })

}]);